import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { $userLanguage, $steamId, $userToken, getUserProfileFx, updatePremiumStatus } from '@/entities/user'
import { $subscriptionPrices } from '@/entities/payments'
import { getLeaderBoardsFx } from '@/entities/leaderboard/effects'
import { useTonConnectUI } from '@tonconnect/ui-react'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import WebApp from '@twa-dev/sdk'
import { goToAuth, goToConnectPlatform } from '@/app/routing/events'
import { postPurchaseDiscount } from '@/entities/user/api'
import { useState } from 'react'

export const PlatinumOffer = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.main.subscriptionDrawer

  const subscriptionPrices = useUnit($subscriptionPrices)

  const userToken = useUnit($userToken)
  const steamId = useUnit($steamId)
  const [tonConnectUI] = useTonConnectUI()
  const isTonWalletConnected = tonConnectUI.connected
  const [isCreating, setIsCreating] = useState(false)

  const handleClick = async () => {
    if (!userToken) return goToAuth()
    if (!subscriptionPrices) {
      return WebApp.showAlert('Oops, ask support why there is no subscription plans')
    }
    if (!steamId && !isTonWalletConnected) {
      return goToConnectPlatform({ platform: 'steam' })
    }

    setIsCreating(true)

    try {
      const platinumOption = subscriptionPrices.find((opt) => opt.description === 'platinum')
      if (!platinumOption) throw new Error('No platinum plan found')

      const response = await postPurchaseDiscount(userToken, platinumOption.id)

      if (response.invoice_url) {
        WebApp.openInvoice(response.invoice_url, async (status) => {
          if (status === 'paid') {
            updatePremiumStatus(false)
            await getUserProfileFx(userToken)
            await getLeaderBoardsFx(userToken)
          }
          setIsCreating(false)
        })
      }
    } catch (err) {
      console.error(err)
      WebApp.showAlert('Payment failed. Please try again.')
      setIsCreating(false)
    }
  }

  return (
    <div className={classes.rootWrapper}>
      <div
        className={classes.root}
        onClick={isCreating ? undefined : handleClick}
        style={{
          backgroundImage: 'url(https://storage.yandexcloud.net/gamed/stuff/platinumOfferBg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          cursor: isCreating ? 'not-allowed' : 'pointer',
          opacity: isCreating ? 0.6 : 1,
        }}
      >
        <div className={classes.iconsContainer}>
          <img src="/assets/subscriptionRelated/gamedLogo.webp" height={19} alt="" />
          <Icon view="platinum" style={{ alignSelf: 'center', width: '60px' }} />
        </div>
        <div className={classes.bottomContainer}>
          <span>{texts.add}</span>
          <Icon view="gamedCoin" width={16} style={{ alignSelf: 'center' }} />
          <span>{texts.toGet}</span>
          <span
            style={{
              background: 'linear-gradient(131deg, #FFC926 -2.34%, #FFF5A9 103.12%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {texts.discount}
          </span>
        </div>
      </div>
    </div>
  )
}
